import { get } from 'modules/api';

export const fetchCities = ({ zipCode, country }) =>
    get('cities/', {
        zipCode,
        country,
    });
